<template>
	<article class="profile-card__wrapper">
		<div class="container-bouton" v-if="!profil.nouser && !profil.unauthorized && !profil.myself">
			<button
				class="bt-supprimer-fiche"
				v-tooltip.top="'Attention, si vous le supprimez, ce profil ne sera plus proposé'"
				@click="dislike">
			<span class="invisible">Supprimer</span></button>
			<button
				v-if="avatars.length <= 1"
				class="tooltip-avec-actif bt-favoris-fiche-deux"
				:class="{ active: value.Favoris }"
				v-tooltip.top="computedUser.FavoriteTooltip[value.Favoris ? 1 : 0]"
				@click="like">
				<svgicon icon="star" class="star-icon"></svgicon>
			</button>
		</div>

		<div class="profile-card" :class="{ 'profile-card--coloc': !profil.pro, 'profile-card--pro': profil.pro }">
			<div class="container-photo" @click="clickable && $router.push({ path: linkToAccount })">
				<chat-picture :users="avatars" :h="'100%'" :w="'100%'"></chat-picture>
				<div class="container-photo__hover" v-if="clickable">Voir profil</div>
			</div>
			<template v-if="!profil.pro">
				<div v-if="computedUser.HasHome === true" class="tooltip picto-favoris-logement" v-tooltip.top="'Logement à partager'" title="Logement à partager">
					<svgicon icon="picto-favoris-logement" class="picto-favoris-logement-icon"></svgicon>
					<span class="invisible">Logement à partager</span>
				</div>
				<div :class="'profil-situation-' + computedUser.ProfilePosition + ' situation-icon'" v-tooltip.top="computedUser.PositionName || 'Inconnue'">
					<svgicon :icon="'picto-profil-situation-'+computedUser.ProfilePosition" :class="computedUser.ProfilePosition+'-icon'"></svgicon>
				</div>
			</template>
			<template v-else>
				<div v-if="computedUser.FullRecord" class="tooltip picto-dossier-complet" v-tooltip.top="'dossier locatif complet'">
					<svgicon :icon="'valid-location-icon'" :class="computedUser.ProfilePosition+'-icon'"></svgicon>
				</div>
				<div :class="'profil-situation-' + computedUser.ProfilePosition + ' situation-icon'" v-tooltip.top="computedUser.PositionName || 'Inconnue'">
					<svgicon :icon="'picto-profil-situation-'+computedUser.ProfilePosition" :class="computedUser.ProfilePosition+'-icon'"></svgicon>
				</div>
			</template>

			<h3 class="profile-card__title">
				<div v-if="computedUser.gdc" class="tooltip picto-gens-de-confiance" v-tooltip.top="'Gens de confiance'" title="Gens de confiance">
					<logo-gdc></logo-gdc>
					<span class="invisible">Gens de confiance</span>
				</div>

				<a
					:href="clickable ? linkToAccount : '#'"
					class="tooltip popup-fiche-detail-deux"
					:title="linkToAccount ? 'Voir le détail' : ''">{{ computedUser.FirstName.toLowerCase() }} {{ computedUser.Name | initial }}</a>
			</h3>
			<p v-if="profil.pro" class="details">{{computedUser.BedroomCount}} chambre<span v-if="computedUser.BedroomCount > 1">s</span><br/>
				<span>&nbsp;</span>
			</p>
			<div class="container-warranty">
				<div v-if="computedUser.WarrantyValid" class="tooltip" v-tooltip.top="'Garanti par Cooloc'" title="Garanti par Cooloc">
					<svgicon icon="logo-oo"></svgicon>
				</div>
			</div>
			<div class="container-matching-bar" v-if="!profil.pro && !profil.nouser && !profil.unauthorized">
				<div class="matching-bar" :id="'matching-bar'+computedUser.UserID+index">
					<div class="container-bar" :class="progressColorClass">
						<div class="progress" :style="{ width: computedUser.SearchScore + '%' }"></div>
					</div>
					<span>{{ Math.round(computedUser.SearchScore) }}%</span>
				</div>
			</div>

			<slot></slot>

			<div v-if="computedUser.LastMessage" class="profile-card__lastmessage">
				<div>Dernier message :</div>
				{{ lastMessageDate }}
			</div>

			<button
				class="bt-contacter"
				:class="{ loading }"
				@click="openMsg">
				<div style="text-transform: uppercase">Contacter</div>
			</button>
		</div>
	</article>
</template>

<script>
import { eventBus, fetchDataHome } from '@/main'
import { formatDistance } from 'date-fns'
import { fr } from 'date-fns/locale'

export default {
  name: 'profile-card',
  props: {
    // User's info
    value: { type: Object, default: () => ({}) },
    // Not the profil, more like a configuration for the rendering
    profil: { type: Object, default: () => ({}) },
    // Position in matching
    index: { type: Number, default: 0 },
    // ???
    clickable: { type: Boolean, default: true },
    // Data from matching, to put in profile url
    searchData: String,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    like() {
      // Pro like user/group
      if (this.profil.pro) {
        const data = {
          like: !this.value.Favoris,
          [this.value.Grouped ? 'group_id' : 'user_id']: this.value.UserID, // UserID = group id when Grouped = true
        }
        return this.$http.post(`/api/homes/accordances/${this.$route.query.home_id || 'default'}`, data).then(() => {
          this.value.Favoris = data.like
          eventBus.$emit('favorisCard', this.index)
        })
      }

      return this.$http.get(`/api/users/${this.computedUser.UserID}/favorite`).then(() => {
        this.value.Favoris = !this.value.Favoris
        eventBus.$emit('favorisCard', this.index)
      })
    },
    dislike() {
      return this.$confirm('Confirmez-vous que vous ne voulez plus voir ce profil ? Celui-ci ne vous sera plus proposé.').then(ok => {
        if (!ok) return

        // Pro dislike user/group
        if (this.profil.pro) {
          const data = {
            dislike: true,
            [this.value.Grouped ? 'group_id' : 'user_id']: this.value.UserID, // UserID = group id when Grouped = true
          }
          return this.$http.post(`/api/homes/accordances/${this.$route.query.home_id || 'default'}`, data).then(() => {
            eventBus.$emit('removeCard', this.index)
            this.$emit('removeCard')
          })
        }

        // User dislike user
        return this.$http.get(`/api/users/${this.computedUser.UserID}/dislike`).then(() => {
          eventBus.$emit('removeCard', this.index)
          this.$emit('removeCard')
        })
      })
    },
    openMsg() {
      this.loading = true
      let promise

      // Fetch home data and add a default message for the messenger
      if (this.profil.pro && !this.computedUser.LastMessage && window.localStorage) {
        promise = fetchDataHome(this, this.$route.query.home_id || 'default').then(
          home => localStorage.setItem('prebuiltMessage', `Bonjour, je vous contacte pour vous proposer ce logement [home ${home.id}]${home.name || ('co-location à ' + home.city)}[/home]. Je reste à votre disposition pour en discuter. Bien cordialement.`),
          err => console.error(err),
        )
      } else {
        promise = Promise.resolve()
      }

      // Redirect to messenger
      let id = this.computedUser.UserID
      if (this.value.Grouped) {
        id = `group-${id}`
      }
      promise.then(() => this.$router.push({ name: 'DashboardMessages', query: { id } }))
    },
  },
  computed: {
    progressColorClass() {
      const progress = this.computedUser.SearchScore
      if (progress > 85) return 'coul-six'
      if (progress > 60) return 'coul-cinq'
      if (progress > 40) return 'coul-quatre'
      if (progress > 20) return 'coul-trois'
      if (progress >= 10) return 'coul-deux'
      return 'coul-un'
    },
    computedUser() {
      const v = this.value
      return {
        UserID: v.UserID || 0,
        HasHome: !!v.HasHome,
        ProfilePosition: v.ProfilePosition || 0,
        PositionName: v.PositionName || '',
        FullRecord: !!v.FullRecord,
        Grouped: !!v.Grouped,
        gdc: !!v.gdc,
        FirstName: v.FirstName || '',
        Name: v.Name || '',
        BedroomCount: Math.trunc(v.BedroomCount) || 0,
        PerRoomBudgetMin: Math.trunc(v.PerRoomBudgetMin) || 0,
        PerRoomBudget: Math.trunc(v.PerRoomBudget) || 0,
        SearchScore: v.SearchScore || 0,
        LastMessage: v.LastMessage || null,
        FavoriteTooltip: ['Ajouter à vos favoris', 'Retirer de vos favoris'],
        WarrantyValid: v.warranty_status === 'validated_eligible' || v.warranty_status === 'accepted',
      }
    },
    avatars() {
      const value = this.value
      if (value.Avatars) {
        if (!value.Avatars.length) {
          return [{ id: null }]
        }
        return this.value.Avatars.map(a => ({
          id: a.id,
          avatar_id: a.id,
          avatar_color: a.color,
        }))
      }
      return [value]
    },
    linkToAccount() {
      if (this.profil.nouser) return '/access'
      if (this.profil.unauthorized) return null

      let res = `/users/${this.computedUser.UserID}/profile`
      if (this.searchData) {
        res += `?s=${this.searchData}-${this.index}`
      }
      return res
    },
    lastMessageDate() {
      return formatDistance(new Date(this.computedUser.LastMessage), new Date(), { locale: fr })
    },
  },
  components: {
    ChatPicture: require('@/ui/ChatPicture').default,
    LogoGdc: require('@/components/common/GensDeConfiance').default,
  },
}
</script>

<style lang="scss">
.profile-card {
	.container-photo {
		position: absolute;
		top: -30px;
		left: 50%;
		transform: translateX(-50%);
		overflow: hidden;
		width: 60px;
		height: 60px;
		max-width: 88px;
		border-radius: 50px;
		&:after {
			content: "";
			display: block;
			padding-bottom: 100%;
		}
		.chat-picture {
			position: absolute;
		}

		&__hover {
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			color: #FFF;
			text-transform: uppercase;
			background: $red;
			display: flex;
			align-items: center;
			text-align: center;

			opacity: 0;
			transition: opacity 0.2s;
			&:hover {
				opacity: 0.4;
			}
		}
	}
	&.profile-card .container-photo {
		cursor: pointer;
	}
	.picto-gens-de-confiance {
		width: 19px;
		height: 19px;
		margin-right: 5px;
		display: inline-block;
	}
	&__title {
		font-size: 22px !important;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		text-transform: capitalize;
	}

	.bt-contacter {
		width: 100%;
		padding: 8px 0;
		margin-top: 10px;
		border: none;
		background: $tan;
		font-size: 13px !important;
		color: $dark;

		&.loading {
			position: relative;

			div {
				visibility: hidden;
			}

			&:after {
				position: absolute;
				top: calc(50% - 8px);
				left: calc(50% - 5px);
				border-color: $dark;
				border-top-color: rgba($dark, 0.2);
				width: 10px;
				height: 10px;
			}

			&:hover:after {
				border-color: #FFF;
				border-top-color: rgba(#FFF, 0.2);
			}
		}
		&:hover {
			color: #FFF;
			background: $red;
		}
	}

  .container-warranty {
    width: 100%;
    height: 48px;
    text-align: center;

    svg {
      width: 48px;
      height: 48px;

      path {
        fill: $red2;
        stroke: $red2;
      }
    }
  }

  .container-matching-bar {
    padding-top: 8px;

    .matching-bar {
      color: #67645f;
      font-size: 12px;
      display: flex;
      align-items: center;

      .progress {
        height: 8px;
      }

      .container-bar {
        margin-right: 5px;
      }
    }
  }

	&__wrapper {
		position: relative;
		padding: 40px 14px 14px !important;

		.container-bouton {
			position: absolute;
			top: -30px;
			left: 0;
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 10px;

			.bt-supprimer-fiche {
				width: 15px;
				height: 15px;
				background: transparent url(../../../static/images/bt-fiche-suppr-fav.svg) no-repeat 0 0;
				background-size: 45px 40px;
				&:hover {
					background-position: 0px -24px;
				}
			}
			.bt-favoris-fiche-deux {
				width: 20px;
				height: 20px;
			}
		}
	}

	&__lastmessage {
		text-align: center;
		color: #67645f;
		font-size: 12px;
		font-weight: 500;
		margin-top: 10px;

		div {
			color: $red;
		}
	}
}
</style>
